var map = {
	"./ashes.png": 3047,
	"./bones.png": 6614,
	"./bronze.png": 4907,
	"./cattail.png": 5865,
	"./cattailseeds.png": 3551,
	"./cinder.png": 3452,
	"./darkness.png": 2190,
	"./deathcap.png": 3821,
	"./driftwood.png": 2365,
	"./fatefabric.png": 4822,
	"./garlic.png": 3641,
	"./garliccloves.png": 9491,
	"./glassrock.png": 9572,
	"./goldenapple.png": 8326,
	"./iron.png": 1849,
	"./limestone.png": 561,
	"./lotus.png": 1614,
	"./mandrakeroot.png": 5212,
	"./mandrakeseeds.png": 2956,
	"./marble.png": 9936,
	"./moly.png": 438,
	"./moondust.png": 8472,
	"./moss.png": 8121,
	"./myrtle.png": 1878,
	"./mysteryseed.png": 8831,
	"./nightmare.png": 3504,
	"./nightshade.png": 6142,
	"./nightshadeseeds.png": 1106,
	"./originseeds.png": 8323,
	"./pearl.png": 351,
	"./plasma.png": 257,
	"./poppy.png": 511,
	"./poppyseeds.png": 6969,
	"./psyche.png": 429,
	"./rubbish.png": 1842,
	"./shaderot.png": 7693,
	"./shadow.png": 5495,
	"./silver.png": 624,
	"./stardust.png": 9487,
	"./tears.png": 1044,
	"./thalamus.png": 542,
	"./wheat.png": 5298,
	"./wheatseeds.png": 4502,
	"./wool.png": 6372,
	"./zodiacsand.png": 5417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;